import { defineComponent as n, openBlock as r, createBlock as a, unref as l, mergeProps as p, withCtx as c, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconMediaPlay",
  __name: "IconMediaPlay",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, e) => (r(), a(l(m), p(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        i("path", { d: "M16.57 11.218c.573.402.573 1.162 0 1.564l-5.684 3.992C10.129 17.307 9 16.839 9 15.993V8.008c0-.846 1.129-1.314 1.886-.782l5.684 3.992" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
